import { Box, LinearProgress } from "@mui/material";

export const LinearLoading = () => {
  return (
    <Box sx={{ width: "100%" }}>
    <LinearProgress />
  </Box>
  )
}
